/**
 * Moduł obsługujący zakładki w paternie CTA section with tabs and mobile app
 */
export function initCtaTabs() {
  const sections = document.querySelectorAll('.cta-section-with-tabs-and-mobile-app');
  
  if (sections.length === 0) return;
  
  sections.forEach(section => {
    const tabs = section.querySelectorAll('.cta-section-with-tabs-and-mobile-app__tab-item');
    const contents = section.querySelectorAll('.cta-section-with-tabs-and-mobile-app__tab-content');
    
    if (tabs.length === 0 || contents.length === 0) return;
    
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));
        
        tab.classList.add('active');
        if (contents[index]) {
          contents[index].classList.add('active');
        }
      });
    });
  });
}

export default initCtaTabs;